/**
 * Route for `real-time-conversion-notifications`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeConversionNotificationsPage } from "../features/real-time-conversion-notifications/RealTimeConversionNotificationsPage";

export const realTimeConversionNotificationsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-conversion-notifications",
	component: RealTimeConversionNotificationsPage,
});

export default realTimeConversionNotificationsRoute;
